import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';

// Без React.StrictMode: у dev-режимі він двічі запускає ефекти, а контролер чату
// тримає з'єднання й камеру та не має створюватися й знищуватися двічі.
createRoot(document.getElementById('root')!).render(<App />);
